module.exports = __webpack_public_path__ + "img/iOS.bdc0d1c7.png";